import { segmentModule } from '@/plugins/segment/SegmentModule'

/**
 * Segment Vue plugin object
 * @type {PluginObject<unknown>}
 */
export const SegmentPlugin = {
  /**
   * @type PluginFunction
   * @param Vue
   */
  install: Vue => {
    /** @type {SegmentClient} */
    Vue.prototype.$segment = segmentModule
  }
}
